import { useAppDispatch, useAppSelector } from "../../../store/hooks/StoreHooks";
import { setIsComparison, setIsJetlift, setIsReports } from "../../../store/jetlift/project-header/ProjectHeaderSlice";

const useJetliftProjectHeaderFacade = () => {
    const dispatch = useAppDispatch();

    const updateIsJetlift = (value: boolean) => {
        dispatch(setIsJetlift(value));
    };

    const updateIsComparison = (value: boolean) => {
        dispatch(setIsComparison(value));
    };

    const updateIsReports = (value: boolean) => {
        dispatch(setIsReports(value));
    };

    return {
        updateIsJetlift,
        updateIsComparison,
        updateIsReports,
    };
};
export default useJetliftProjectHeaderFacade;